import React, { useEffect, useState, useCallback } from 'react';
import { useMessage } from '../../contexts/MessageContext';
import OccurModal from './OccurModal';
import ProcessModal from './ProcessModal';
import {
  fetchEmergencyAlerts,
  fetchEmergencyCount,
  submitEmergencyEnds,
  checkEmergencyAlert,
} from '../../services/dashboardService';

export default function EmergenceAlert() {
  const { selectedAlertId, setReceiveHandler, setSelectedAlertId, triggerReceive, setTriggerReceive, forceOpenModalType, setForceOpenModalType } = useMessage();
  const [occurList, setOccurList] = useState([]);
  const [doneCount, setDoneCount] = useState(0);
  const [processList, setProcessList] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [endList, setEndList] = useState([]);
const loadDoneCount = useCallback(async () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const res = await fetchEmergencyCount(token);
    if (res.success) {
      setDoneCount(res.emergency_end_count);
    }
  } catch (err) {
    console.error("❌ 완료 카운트 불러오기 실패:", err);
  }
}, []);
  // 🔄 응급상황 리스트 불러오기
  const loadEmergencyAlerts = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await fetchEmergencyAlerts(token);
      if (res.success && res.user_alert) {
        const formatted = res.user_alert.map((item) => ({
          id: item.id,
          name: item.name,
          address: item.address,
          age: item.age,
          gender: item.sex,
          status: item.pec,
          alert_id: item.alert_id,
          report_id: item.report_id,
          create_date: item.create_date,
        }));

        setOccurList(formatted.filter(i => i.report_id === null));
        setProcessList(formatted.filter(i => i.report_id !== null));
      }
    } catch (err) {
      console.error("❌ 리스트 불러오기 실패:", err);
    }
  }, []);

  // 🔔 FCM 알림 처리
  useEffect(() => {
    setReceiveHandler(() => {
      loadEmergencyAlerts();
    });
    loadEmergencyAlerts();
  }, [loadEmergencyAlerts, setReceiveHandler]);

  // 🔹 forceOpenModalType에 따라 모달 열기
  useEffect(() => {
    if (forceOpenModalType) {
      setModalType(forceOpenModalType);
      setForceOpenModalType(null);
    }
  }, [forceOpenModalType, setForceOpenModalType]);

  // 🔹 selectedAlertId가 있을 경우 ProcessModal 열기
  useEffect(() => {
    if (selectedAlertId && processList.length > 0) {
      const matched = processList.find(p => String(p.alert_id) === String(selectedAlertId));
      if (matched) {
        setModalType('process');
        setSelectedAlertId(null);
      }
    }
  }, [selectedAlertId, processList, setSelectedAlertId]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const loadCount = async () => {
      const res = await fetchEmergencyCount(token);
      if (res.success) {
        setDoneCount(res.emergency_end_count);
      }
    };

    loadCount();
  }, []);

useEffect(() => {
  const getEndList = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      // ✅ 상황종료 리스트 전용 API 호출
      const res = await fetchEmergencyAlerts(token); 
      if (res.success && res.user_alert) {
        // report_id가 있는 항목만 종료 처리된 리스트로 분류
        const formatted = res.user_alert
          .filter(i => i.report_id !== null)
          .map((item) => ({
            id: item.id,
            name: item.name,
            address: item.address,
            age: item.age,
            gender: item.sex,
            status: item.pec,
            alert_id: item.alert_id,
            report_id: item.report_id,
            create_date: item.create_date,
          }));
        setEndList(formatted);
      }
    } catch (err) {
      console.error("❌ 상황종료 리스트 불러오기 실패:", err);
    }
  };

  getEndList();
}, []);


 // 상황종료 버튼 클릭 시
const handleOpenProcessModal = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;
  console.log("비어있냐?", token)
  try {
    // 1️⃣ 상황종료 처리 (여기서는 alert_id가 필요한 경우, 없으면 단순 조회 API 사용)
    // 단일 alert 종료 처리용이라면 alert_id를 넣어 호출
    // const res = await submitEmergencyEnds(alert_id, token);

    // 2️⃣ 전체 리스트 조회
    const res = await submitEmergencyEnds(token);
    console.log("aaaaaaaaaaaaaaaaaa", res)
    if (res.success && res.user_alert) {
      // 3️⃣ report_id !== null 항목만 필터링 → 지금까지 종료된 항목
      const endItems = res.user_alert
        .filter(item => item.report_id !== null)
        .map(item => ({
          id: item.id,
          name: item.name,
          address: item.address,
          age: item.age,
          gender: item.sex,
          status: item.pec,
          alert_id: item.alert_id,
          report_id: item.report_id,
          create_date: item.create_date,
        }));

      setEndList(endItems); // ProcessModal로 전달
      setModalType('process');
      await loadDoneCount();
    }
  } catch (err) {
    console.error("❌ 상황종료 리스트 불러오기 실패:", err);
  }
};



  // 🔹 발생현황에서 확인 클릭
 const handleReceive = async (alert_id) => {
  const token = localStorage.getItem("token");
  if (!token) return;

  const res = await checkEmergencyAlert(alert_id, token);
  if (res.success) {
    await loadEmergencyAlerts();

    // ✅ 발생현황 리스트가 아니라 API에서 내려준 전체 리스트 사용
    setEndList(res.user_alert);
    console.log(res.user_alert);
    setModalType('process');
    await loadDoneCount();
  } else {
    alert(res.message || "접수 실패");
  }
};

  return (
    <div className="alert dashboard_box">
      <h4>응급상황 현황</h4>
      <div className="buttonwrp">
        <p className='tit'></p>
        <p className='txtwrp'>최근 한 달 동안 발생한 <br />응급상황 현황을 확인할 수 있습니다</p>
        <ul className="clear_fix">
          <li className="ball01">
            <button onClick={() => setModalType('occur')}>
              <p className="num">{occurList.length}</p>
            </button>
            <p className="txt">발생현황</p>
          </li>
         <li className="ball02">
            <button onClick={handleOpenProcessModal}>
              <p className="num">{doneCount}</p>
            </button>
            <p className="txt">상황종료</p>
          </li>
        </ul>
      </div>

      {modalType === 'occur' && (
        <OccurModal data={occurList} onReceive={handleReceive} onClose={() => setModalType(null)} />
      )}
      {modalType === 'process' && (
        <ProcessModal
          data={endList}
          onClose={() => setModalType(null)}
          onCancel={(item) => console.log("취소", item)}
        />
      )}
    </div>
  );
}
